/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-script-url */
import React, { useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';
import SvgCaretRight from '@digital-hig/icon/lib/build/ui-controls/caret-right';
import SvgCaretDown from '@digital-hig/icon/lib/build/ui-controls/caret-down';
import SvgCaretUp from '@digital-hig/icon/lib/build/ui-controls/caret-up';
import Typography from '@digital-hig/typography';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from '@mui/material';
import { SecondaryNavRootElement } from './style';
import { DEFAULT_LANGUAGE } from '../../../constants/app-constants';

const SecondaryNav = () => {
  const { t, i18n: i18next } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(DEFAULT_LANGUAGE);
  const [activeTab, setActiveTab] = useState(null);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const param = useParams();
  const dropdownRefs = useRef([]);

  if (!dropdownRefs.current) {
    dropdownRefs.current = [];
  }

  const langPara = param?.locale ? `/${param.locale}` : '';
  const handleTabClick = (index) => {
    if (activeTab === index) {
      setActiveTab(null);
    } else {
      setActiveTab(index);
    }
  };
  const handleMobileToggle = () => {
    setIsMobileNavOpen((prev) => !prev);
  };
  const domainName = 'https://www.autodesk.com';
  const tabs = [
    {
      label: 'Overview',
      path: '/partners/overview',

    },
    {
      label: 'Work with a Partner',
      children: [
        { label: 'Learn about Partners', path: '/partners/work-with-a-partner' },
        { label: 'Industry and Technology Partners', path: '/partners/industry-and-technology' },
        { label: 'Services Partners', path: '/partners/services' },
        { label: 'Training & Certification Partners', path: '/training-and-certification/overview' },
      ],
    },
    {
      label: 'Partner with Autodesk',
      children: [
        { label: 'Partner Programs', path: '/partners/partner-with-autodesk' },
        { label: 'Technology Partners', path: '/partners/technology' },
        { label: 'Learning Partners', path: '/partners/learning' },
      ],
    },
  ];

  useEffect(() => {
    if (i18next.language && selectedLanguage && i18next.language !== selectedLanguage) {
      setSelectedLanguage(i18next.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleClickOutside = (event) => {
      const clickedOutsideAll = dropdownRefs.current.every(
        (ref) => ref && !ref.contains(event.target),
      );

      if (clickedOutsideAll) {
        setActiveTab(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMobileNavOpen]);

  return (
    <SecondaryNavRootElement>
      <Box className="top-navigation">
        <Box className="secondary-navigation">
          <Box className="left secnavigation-head">
            <Box className="top-nav-title">
              <Typography variant="headline-smallest" className="bar-title nav-head">
                {t('Partner Finder')}
              </Typography>
              <Typography variant="headline-smallest" className="mobile nav-toggle" onClick={handleMobileToggle}>
                {isMobileNavOpen ? <SvgCaretUp width="15px" /> : <SvgCaretDown width="15px" />}
              </Typography>
            </Box>
            <Box className={`sectabcls${isMobileNavOpen ? ' show' : ''}`}>
              {tabs.map((tab, index) => (
                <Box key={t(tab.label)} className="menu-links" onMouseLeave={() => setActiveTab(null)}>
                  <Link
                    className="menu-item"
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '16px 14px !important',
                      gap: 2,
                      fontSize: '0.875rem',
                      fontWeight: 600,
                      color: '#000 !important',
                      boxSizing: 'border-box',
                    }}
                    href={tab.path ? `${domainName}${langPara}${tab.path}` : '#'}
                    onClick={(e) => {
                      if (tab.path) {
                        e.preventDefault();
                      } else {
                        handleTabClick(index);
                      }
                    }}
                    ref={(el) => {
                      dropdownRefs.current[index] = el;
                    }}
                    data-wat-val={tab.label}
                    data-wat-loc="Sub Menu"
                  >
                    <span>
                      {!tab.path
                        && (
                          <SvgCaretRight
                            className={`mobile-caret-down ${activeTab === index ? 'open' : ''}`}
                            width="14px"
                            height="14px"
                            style={{
                              transition: 'transform 0.3s ease',
                              transform: activeTab === index ? 'rotate(90deg)' : 'rotate(0deg)',
                            }}
                          />
                        )}
                      {t(tab.label)}
                    </span>
                    {!tab.path
                      && (activeTab === index ? (
                        <SvgCaretUp className="desktop-caret-down" width="12px" />
                      ) : (
                        <SvgCaretDown className="desktop-caret-down" width="12px" />
                      ))}
                  </Link>
                  <Box className="navmenucls" sx={{ position: 'relative' }}>
                    {!tab.path && activeTab === index && (
                      <ul>
                        {tabs[index].children.map((menuLinks) => (
                          <li key={t(menuLinks.label)}>
                            <Link href={menuLinks.path ? `${domainName}${langPara}${menuLinks.path}` : undefined} data-wat-val={menuLinks.label} data-wat-loc="Sub Menu">
                              {t(menuLinks.label)}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </SecondaryNavRootElement>
  );
};

export default SecondaryNav;
